module.exports = __webpack_public_path__ + "static/media/IMG_8047.0eb1a18b.jpg";